import React from "react";
import { InputBase, FormHelperText } from "@mui/material";
import styled from "styled-components";
import { fonts, Spacing } from "../../config";

interface InputTextProps {
  label?: string;
  error?: string;
  value?: any;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  inputRef?: React.Ref<any>;
  type?: string;
  readOnly?: boolean;
  placeholder?: string;
}

const FieldLabel = styled.p(({ theme }: any) => ({
  fontFamily: fonts.semibold,
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "15px",
  paddingBottom: "8px",
  margin: 0,
  color: theme.palette.text.primary,
  [theme.breakpoints.down("sm")]: {
    paddingBottom: "4px",
  },
}));

const StyledInput = styled(InputBase)(({ theme }: any) => ({
  "&&.MuiInputBase-root": {
    backgroundColor: "#F0F0F0",
    borderRadius: "21px",
    paddingBlock: "14px",
    paddingInline: "20px",
    fontSize: "14px",
    width: "100%",
    "& input": { padding: 0 },
    "&::before, &::after": { display: "none" },
    [theme.breakpoints.down("sm")]: {
      paddingBlock: "10px",
      paddingInline: "15px",
    },
  },
}));

const FieldError = styled(FormHelperText)(({ theme }: any) => ({
  color: "red",
  minHeight: Spacing(2.5),
  [theme.breakpoints.down("sm")]: {
    minHeight: Spacing(2),
  },
}));

function InputText({
  label,
  error,
  value,
  onChange,
  onBlur,
  inputRef,
  type,
  readOnly,
  placeholder,
}: InputTextProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <StyledInput
        inputRef={inputRef}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        type={type}
        inputProps={{ readOnly }}
        placeholder={placeholder}
      />
      <FieldError>{error ?? " "}</FieldError>
    </div>
  );
}

export default InputText;
